import { createSlice } from '@reduxjs/toolkit';
import { vendorAction } from 'redux/action/vendorAction';

const initialState = {
	isLoading: false,
	data: [],
	error: null,
};

const vendorSlice = createSlice({
	initialState,
	name: 'vendor',
	reducers: {
		resetVendors: (state) => {
			state.data = [];
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(vendorAction.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(vendorAction.fulfilled, (state, action) => {
			state.data = action.payload;
			state.isLoading = false;
		});
		builder.addCase(vendorAction.rejected, (state, action: any) => {
			state.error = action.error;
			state.isLoading = false;
		});
	},
});

export const { resetVendors } = vendorSlice.actions;
export default vendorSlice;
